import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import {
	CreateSubcategoryModalContext,
	ICreateSubcategoryModalContext,
} from '../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import React, { useContext } from 'react';
import { InputFields } from './components/InputFields/InputFields';
import classNames from 'classnames';
import style from './MainInfo.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '18:13',
		optimalResolutions: {
			a: '324*234px',
			b: '648*468px',
		},
	},
	vertical: {
		ratio: '25:13',
		optimalResolutions: {
			a: '500*260px',
			b: '1000*520px',
		},
	},
};

interface IMainInfo {
	isVisible: boolean;
}

export const MainInfo: React.FC<IMainInfo> = ({ isVisible }) => {
	const { setFileId, fileId } = useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={containerClasses} data-test="CreateSubcategoryModalForm">
			<div className={style.leftHalf}>
				<FormImageUploader
					containerClass={style.imageUploader}
					maxFileSizeMB={1}
					fileId={fileId}
					setFileId={setFileId}
					deletePhotoHandler={deletePhotoHandler}
					horizontalAspectRatio={324 / 234}
					verticalAspectRatio={500 / 260}
					descriptionOfAspectRatio={descriptionOfAspectRatio}
				/>
			</div>
			<div className={style.rightHalf}>
				<InputFields />
			</div>
		</div>
	);
};
